import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DropDownBox from "../../Fields/DropDownBox";
import { Typography } from "@material-ui/core";
import TextInput from "../../Fields/TextInput";
import { getDocsUrl } from '../../../helpers/docsUrl';
import { Button } from "react-bootstrap";
import CMSearchService from "../../../services/CMSearchService";
import { toast } from 'react-toastify';
import GQPopup from "../GQPopups/GQPopup";
import { useSelector } from "react-redux";


const SearchDetails = (props) =>{

    const { t, i18n } = useTranslation('common');
    const toggle = useSelector(state => state.setToggle.toggle);

    const {formJson, setFormJson, selectSearchTemplate, linkRef} = props

    const [errorString, setErrorString] = useState("")
    const [confirmDeleteUI, setConfirmDeleteUI] = useState(false);
    const [renameUI, setRenameUI] = useState(false);
    const [renameValue, setRenameValue] = useState("");
    const [actionTemplateName, setActionTemplateName] = useState("");

    useEffect(()=>{

        if(formJson !== undefined && formJson !== null){
            if(!formJson.searchInfo.title && formJson.searchInfo.title !== ""){
                //format to: "CM YYYY-MM-DD HH:mm:ss" (12-hour, no AM/PM)
                let dateStr = new Date().toLocaleString('en-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                }).replace(',', '').replace(/\//g, '-');
                // Remove AM/PM
                dateStr = dateStr.replace(/\s*A.M.$/i, '').replace(/\s*P.M.$/i, '');
                formJson.searchInfo.title = "CM " + dateStr;
                setFormJson({...formJson});
            }
        }

    },[formJson])

    const convertPreferences = () =>{
        if(formJson && formJson.layout && formJson.layout.search_preferences != null){
            return formJson.layout.search_preferences
                .filter(pref => pref != null && pref !== "")
                .map(pref => ({ label: pref, value: pref }));
        }
        return [];
    }

    const handleDeleteTemplate = async () => {
        const name = actionTemplateName;
        if (!name) return;
        const response = await CMSearchService.deleteCMTemplate(name);
        if (response !== undefined) {
            formJson.layout.search_preferences = (formJson.layout.search_preferences || []).filter(p => p !== name);
            if (formJson.layout.template === name) formJson.layout.template = null;
            setFormJson({...formJson});
            toast.success("Template deleted successfully");
        } else {
            toast.error("Error deleting template");
        }
        setConfirmDeleteUI(false);
        setActionTemplateName("");
    };

    const handleRenameTemplate = async () => {
        const oldName = actionTemplateName;
        const newName = renameValue.trim();
        if (!newName || !oldName || newName === oldName) {
            setRenameUI(false);
            setRenameValue("");
            setActionTemplateName("");
            return;
        }
        const existingNames = (formJson.layout.search_preferences || []).map(p => String(p));
        if (existingNames.includes(String(newName))) {
            toast.error("A template with this name already exists");
            return;
        }
        const loaded = await CMSearchService.getCMTemplate(oldName);
        if (!loaded || !loaded.response_content) {
            toast.error("Error loading template for rename");
            return;
        }
        const templateData = loaded.response_content.map || loaded.response_content;
        const saveData = {...templateData, template_name: newName};
        const saveResponse = await CMSearchService.saveCMTemplate(saveData);
        if (saveResponse !== undefined) {
            await CMSearchService.deleteCMTemplate(oldName);
            formJson.layout.search_preferences = (formJson.layout.search_preferences || []).map(p => p === oldName ? newName : p);
            if (formJson.layout.template === oldName) formJson.layout.template = newName;
            setFormJson({...formJson});
            toast.success("Template renamed successfully");
        } else {
            toast.error("Error renaming template");
        }
        setRenameUI(false);
        setRenameValue("");
        setActionTemplateName("");
    };

    return(
        <div style={{height: "120px"}}>

           <div style={{padding: "15px"}}>
           </div>
            <div hidden={formJson.layout.syscontrol_search_submit !== ""} style={{padding: "0 15px", display:"flex", width: "100%", justifyContent: "center"}}>
                <Typography className="text-danger">
                    {t('ABsearchDisableText')}
                    {formJson.layout.syscontrol_search_text}
                    {t('patienceThanksText')}
                </Typography>
            </div>


            <div style={{display: "flex", layout: "row", width: "100%"}}>
                <p className="subHeading w-50 mb-10">{t('searchDetails')}</p>
                <div style={{display:"flex", width: "100%", justifyContent: "right"}}>
                    <a
                        className={"appLink"}
                        href={linkRef? linkRef : getDocsUrl('ip_sequence_searching.html')}
                        target="_blank" rel="noreferrer" >{t('help')}
                    </a>
                </div>
            </div>
            <div style={{display: "flex", layout: "row", width: "100%", justifyContent: "space-between"}}>
                <div className="form-group" style={{width: "400px"}}>
                    <TextInput
                        fullWidth
                        spellCheck="false"
                        id="searchDetails"
                        label={t('nameYourSearch')}
                        value={formJson.searchInfo.title}
                        onChange={(e)=>{
                            let val = e.currentTarget.value

                            //check for html tags or special characters
                            let anyErrors = false;
                            if(/[\<\>\\\&\/]/g.test(val)){
                                setErrorString("Invalid search title");
                                anyErrors = true;
                            }

                            //check for empty value
                            if(val == ""){
                                setErrorString("Please name your search");
                                anyErrors = true;
                            }

                            if(anyErrors){
                                if(!formJson.layout.errorIdList.includes("searchDetails")){
                                    formJson.layout.errorIdList.push("searchDetails")
                                }
                            }else{
                                //remove id from error list
                                if(formJson.layout.errorIdList){
                                    const index = formJson.layout.errorIdList.indexOf("searchDetails");
                                    if (index > -1) {
                                        formJson.layout.errorIdList.splice(index, 1);
                                    }
                                }
                                setErrorString("")
                            }

                            formJson.searchInfo.title = val
                            setFormJson({...formJson});
                        }}

                        error={errorString !== ""}
                        helperText={errorString}
                        variant="outlined"

                    />
                </div>
                <div style={{display:"flex", alignItems: "center", gap: "4px"}}>
                    <DropDownBox
                        margin="normal"
                        variant="outlined"
                        name={"preferences"}
                        label={"CM search templates"}
                        value={formJson.layout.template != null ? formJson.layout.template : ""}
                        items={convertPreferences()}
                        onChange={(e) => {
                            selectSearchTemplate(e.target.value)
                        }}
                        onEdit={(val) => { setActionTemplateName(val); setRenameValue(val); setRenameUI(true); }}
                        onDelete={(val) => { setActionTemplateName(val); setConfirmDeleteUI(true); }}
                    />
                </div>
            </div>

            <GQPopup
                show={confirmDeleteUI}
                close={() => setConfirmDeleteUI(false)}
                innerHtml={
                    <div style={{width: "400px", padding: "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <span className="center historyPopupHeader tableCaption">Delete Template</span>
                        </div>
                        <p>Are you sure you want to delete the template <strong>{actionTemplateName}</strong>?</p>
                        <div style={{display: "flex", justifyContent: "flex-end", gap: "8px"}}>
                            <Button className={"submitButtonClass"} onClick={() => setConfirmDeleteUI(false)}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={handleDeleteTemplate}>Delete</Button>
                        </div>
                    </div>
                }
            />

            <GQPopup
                show={renameUI}
                close={() => { setRenameUI(false); setRenameValue(""); setActionTemplateName(""); }}
                innerHtml={
                    <div style={{width: "400px", padding: "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <span className="center historyPopupHeader tableCaption">Rename Template</span>
                        </div>
                        <input
                            onChange={(e) => setRenameValue(e.target.value)}
                            value={renameValue}
                            style={{width: "100%", padding: "8px", fontSize: "14px", boxSizing: "border-box", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? 'black' : 'white'}}
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="New template name"
                        />
                        <div style={{display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "10px"}}>
                            <Button className={"submitButtonClass"} onClick={() => { setRenameUI(false); setRenameValue(""); setActionTemplateName(""); }}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={handleRenameTemplate}>Rename</Button>
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default SearchDetails